import { useState, useEffect } from 'react';

import { historyService } from '@/services/api/historyService';
import type { NoteHistoryEvent } from '@/types/notes';

interface UseNoteHistoryQueryResult {
  events: NoteHistoryEvent[];
  isLoading: boolean;
}

export function useNoteHistoryQuery(noteId: string): UseNoteHistoryQueryResult {
  const [events, setEvents] = useState<NoteHistoryEvent[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchHistory(): Promise<void> {
      setIsLoading(true);
      try {
        const response = await historyService.getForNote(noteId);
        if (!cancelled) setEvents(response.data.events);
      } catch {
        if (!cancelled) setEvents([]);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }

    fetchHistory();
    return () => {
      cancelled = true;
    };
  }, [noteId]);

  return { events, isLoading };
}
